import api from "api";

export const getNoParams = async (endpoint: string) => {
  try {
    const res = await api.get(endpoint);

    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (err) {
    const error: any = err;

    if (error.response && error.response.data && error.response.data.errors) {
      return {
        response: null,
        errors: error.response.data.errors,
      };
    } else {
      return {
        response: null,
        errors: true,
      };
    }
  }
};

export const getWithParams = async (endpoint: string, params: any) => {
  try {
    const res = await api.get(endpoint, { params });

    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (err) {
    const error: any = err;

    if (error.response && error.response.data && error.response.data.errors) {
      return {
        response: null,
        errors: error.response.data.errors,
      };
    } else {
      return {
        response: null,
        errors: true,
      };
    }
  }
};

export const postWithParams = async (endpoint: string, params: any) => {
  try {
    const res = await api.post(endpoint, params);

    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (err) {
    const error: any = err;

    if (error.response && error.response.data && error.response.data.errors) {
      return {
        response: null,
        errors: error.response.data.errors,
      };
    } else {
      return {
        response: null,
        errors: true,
      };
    }
  }
};

export const postNoParams = async (endpoint: string) => {
  try {
    const res = await api.post(endpoint);

    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (err) {
    const error: any = err;

    if (error.response && error.response.data && error.response.data.errors) {
      return {
        response: null,
        errors: error.response.data.errors,
      };
    } else {
      return {
        response: null,
        errors: true,
      };
    }
  }
};
